import { render, staticRenderFns } from "./activitiesReview.vue?vue&type=template&id=41dfd5fe&scoped=true&"
import script from "./activitiesReview.vue?vue&type=script&lang=js&"
export * from "./activitiesReview.vue?vue&type=script&lang=js&"
import style0 from "./activitiesReview.vue?vue&type=style&index=0&id=41dfd5fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dfd5fe",
  null
  
)

export default component.exports